import { formValueSelector } from 'redux-form';
import { stringToBoolean } from '../../single-choice/utils/selection';
import { toSelectionInput } from '../../common/pick-and-choose';
export const getGraphQlSelection = (productId, formSection) => ({
  form,
  state
}) => {
  var _formData$value, _formData$value$segme, _formData$value2, _formData$segments;
  const formData = formValueSelector(form)(state, formSection);
  if (!productId || !stringToBoolean(formData === null || formData === void 0 || (_formData$value = formData.value) === null || _formData$value === void 0 ? void 0 : _formData$value.value)) {
    return null;
  }
  const committedSegments = (_formData$value$segme = formData === null || formData === void 0 || (_formData$value2 = formData.value) === null || _formData$value2 === void 0 ? void 0 : _formData$value2.segments) !== null && _formData$value$segme !== void 0 ? _formData$value$segme : [];
  const segments = committedSegments.length ? committedSegments : (_formData$segments = formData === null || formData === void 0 ? void 0 : formData.segments) !== null && _formData$segments !== void 0 ? _formData$segments : [];
  const selectionLoungePerSegment = toSelectionInput(segments);
  if (selectionLoungePerSegment.length === 0) {
    return null;
  }
  return {
    productId,
    selectionLoungePerSegment
  };
};
export default getGraphQlSelection;
//# sourceMappingURL=getGraphQlSelection.js.map